import {
  RecommendationDistribution,
  RecommendationDistributionStatus
} from '@/common/model/recommend/recommendationDistribution'
import { WidgetContentType } from '@/common/model/recommend/widget'

import { BadgeType } from '@/components/view/atoms/badge/Badge'

export const distributionStatusName = (status: RecommendationDistributionStatus) => {
  switch (status) {
    case RecommendationDistributionStatus.DRAFT:
      return '未配信'
    case RecommendationDistributionStatus.RUNNING:
      return '配信中'
    case RecommendationDistributionStatus.TESTING:
      return 'A/Bテスト中'
    case RecommendationDistributionStatus.ENDED:
      return '配信終了'
  }
}

export const distributionStatusBadgeType = (
  status: RecommendationDistributionStatus
): BadgeType => {
  switch (status) {
    case RecommendationDistributionStatus.DRAFT:
      return BadgeType.DEFAULT
    case RecommendationDistributionStatus.RUNNING:
      return BadgeType.SUCCESS
    case RecommendationDistributionStatus.TESTING:
      return BadgeType.EMPHASIS
    case RecommendationDistributionStatus.ENDED:
      return BadgeType.SECONDARY
  }
}

// 配信のコンテンツタイプはバリアント(widget)から導出する。
export const distributionContentType = (
  distribution: RecommendationDistribution
): WidgetContentType | null => {
  return distribution.variants[0]?.content_type ?? null
}

// テスト中・終了済みの配信は編集不可。
export const isDistributionReadOnly = (status: RecommendationDistributionStatus): boolean => {
  return (
    status === RecommendationDistributionStatus.TESTING ||
    status === RecommendationDistributionStatus.ENDED
  )
}
